import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDown,
  faArrowUp,
  faArrowsRotate,
  faCalendarAlt,
  faChartLine,
  faCheck,
  faCheckCircle,
  faClockRotateLeft,
  faClone,
  faDownload,
  faExclamationCircle,
  faFileInvoiceDollar,
  faFileSignature,
  faFilter,
  faInfoCircle,
  faListCheck,
  faMagnifyingGlass,
  faRightFromBracket,
  faSort,
  faSortDown,
  faSortUp,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';

type IconProps = {
  color?: string;
  iconName:
    | 'faArrowDown'
    | 'faArrowUp'
    | 'faArrowsRotate'
    | 'faCalendarAlt'
    | 'faChartLine'
    | 'faCheck'
    | 'faCheckCircle'
    | 'faClockRotateLeft'
    | 'faClone'
    | 'faDownload'
    | 'faExclamationCircle'
    | 'faFileInvoiceDollar'
    | 'faFileSignature'
    | 'faFilter'
    | 'faInfoCircle'
    | 'faListCheck'
    | 'faMagnifyingGlass'
    | 'faRightFromBracket'
    | 'faSort'
    | 'faSortDown'
    | 'faSortUp'
    | 'faSquare'
    | 'faSquareCheck'
    | 'faTimes'
    | 'faTimesCircle'
    | 'faTrashAlt'
    | 'faUser'
    | 'faUsers';
};

const Icon = ({ iconName, color = 'inherit' }: IconProps) => {
  const icons: { [iconName: string]: any } = {
    faArrowDown,
    faArrowUp,
    faArrowsRotate,
    faCalendarAlt,
    faChartLine,
    faCheck,
    faCheckCircle,
    faClockRotateLeft,
    faClone,
    faDownload,
    faExclamationCircle,
    faFileInvoiceDollar,
    faFileSignature,
    faFilter,
    faInfoCircle,
    faListCheck,
    faMagnifyingGlass,
    faRightFromBracket,
    faSort,
    faSortDown,
    faSortUp,
    faSquare,
    faSquareCheck,
    faTimes,
    faTimesCircle,
    faTrashAlt,
    faUser,
    faUsers,
  };

  return <FontAwesomeIcon icon={icons[iconName]} color={color} size='1x' />;
};

export default Icon;
